import moment from 'moment';
import _isNil from 'lodash/isNil';

export function isAuditDataAvailableForDate(date, availableDays) {
  if (_isNil(date) || _isNil(availableDays)) return true;

  return date.isSameOrAfter(moment().subtract(availableDays, 'd'));
}
